import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { OrderDetails_order } from "../../types/OrderDetails";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    dialogTextMarginBottom: {
      marginBottom: "24px"
    },
    labelMargin: {
      marginBottom: "3px"
    },
    muiDialogContentOverrides: {
      "& .MuiInputLabel-root": {
        "& .MuiFormLabel-asterisk": {
          color: "#db3131"
        },
        overflowX: "visible"
      }
    },
    selectMarginBottom: {
      marginBottom: "13px"
    }
  },
  { name: "OrderMarkAsCompletedDialog" }
);

export interface OrderMarkAsCompletedDialogProps extends DialogProps {
  handleSubmit: any;
  order: OrderDetails_order;
  open: boolean;
}

const OrderMarkAsCompletedDialog: React.FC<OrderMarkAsCompletedDialogProps> = props => {
  const { onClose, handleSubmit, order, open } = props;

  const classes = useStyles(props);

  const handleMarkAsShippedConfirmation = (): void => {
    const delType =
      order && order.shippingMethod && order.shippingMethod.deliveryType;

    if (
      delType === "EXPRESS" ||
      delType === "NEXT_DAY" ||
      delType === "EXPRESS_LONG_DISTANCE" ||
      delType === "SAME_DAY" ||
      delType === "NATIONWIDE_DELIVERY"
    ) {
      handleSubmit("DELIVERED");
    } else if (delType === "IN_STORE_PICKUP") {
      handleSubmit("PICKED_UP");
    }
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent className={classes.muiDialogContentOverrides}>
        <DialogContentText className={classes.dialogTextMarginBottom}>
          <FormattedMessage defaultMessage="Are you sure you want to mark this order as completed?" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="closeDialogBtn" onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          id="confirmDialogBtn"
          onClick={handleMarkAsShippedConfirmation}
          color="primary"
          variant="contained"
          className={classes.buttonConfirm}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
OrderMarkAsCompletedDialog.displayName = "OrderMarkAsCompletedDialog";
export default OrderMarkAsCompletedDialog;
